import '../styles/Siniestro.css'
import { Accordion } from 'react-bootstrap';

const Siniestro = ({ siniestros, pasosSiniestros }) => {

    const tabs_perfil = (active) => {
        let items = document.querySelectorAll(".nav-perfil-links li.nav-item");
        let items_body = document.querySelectorAll(".tab-pane");

        if(active === "8"){
            items_body[0].classList.add("active");
            items_body[1].classList.remove("active");
            items_body[2].classList.remove("active");
            items_body[3].classList.remove("active");

            items[0].classList.add("item_activado");
            items[1].classList.remove("item_activado");
            items[2].classList.remove("item_activado");
            items[3].classList.remove("item_activado");
        }else if(active === "9"){
            items_body[0].classList.remove("active");
            items_body[1].classList.add("active");
            items_body[2].classList.remove("active");
            items_body[3].classList.remove("active");

            items[0].classList.remove("item_activado");
            items[1].classList.add("item_activado");
            items[2].classList.remove("item_activado");
            items[3].classList.remove("item_activado");
        }else if(active === "10"){
            items_body[0].classList.remove("active");
            items_body[1].classList.remove("active");
            items_body[2].classList.add("active");
            items_body[3].classList.remove("active");

            items[0].classList.remove("item_activado");
            items[1].classList.remove("item_activado");
            items[2].classList.add("item_activado");
            items[3].classList.remove("item_activado");
        }else if (active === "11"){
            items_body[0].classList.remove("active");
            items_body[1].classList.remove("active");
            items_body[2].classList.remove("active");
            items_body[3].classList.add("active");

            items[0].classList.remove("item_activado");
            items[1].classList.remove("item_activado");
            items[2].classList.remove("item_activado");
            items[3].classList.add("item_activado");
        }
    }

    return (
        <div className="container-fluid">
            <div className="container">
                <div className="homeout__coberturas" id="siniestro">
                    <h1 className='fw-bold ' >Reporta un siniestro</h1>
                    <p>Reúne los documentos abajo listados y comunícate al <a style={{'color': 'var(--green)'}} href='tel:800 801 0132'>800 801 0132</a> <div className='d-lg-block d-none'></div>de lunes a sábado de 09:00 a 18:00 hrs. para ayudarte a continuar con tu proceso de reclamo de siniestro.</p>
                    
                    {/* VERSION MOBILE */}
                    <div className="pt-5 pb-5 d-block d-lg-none">
                        <Accordion defaultActiveKey="0" flush>
                            {
                                siniestros && (
                                    siniestros.map((siniestro,index) => {
                                        let pasoFiltrados = pasosSiniestros.filter((ps) =>  ps.idTabSiniestro === siniestro.id)
                                        return (
                                            <Accordion.Item eventKey={String(index)} key={index}>
                                                <Accordion.Header><div className="header__accordion  " >{siniestro.tituloTab}</div></Accordion.Header>
                                                <Accordion.Body style={{ background: 'var(--gris-claro)' }}>
                                                    <div style={{ marginBottom: '4rem' }} className='texto__siniestro__div'>
                                                        <p>Para hacer efectivo el pago de la indemnización por esta cobertura, deberás contar con los siguientes documentos:</p>
                                                        <br/>
                                                        <ol className=" texto__siniestro list-group-numbered">
                                                            {
                                                                pasoFiltrados.map((paso,indexPaso) => {
                                                                    return (
                                                                        <li key={`${indexPaso}-li-0`} className="list-group-item d-flex justify-content-between align-items-start">
                                                                            <div className="ms-2 me-auto paso__siniestro">
                                                                                <p style={{fontSize:'15px'}} className='fw-fw-normal  ' dangerouslySetInnerHTML={{__html: paso.descripcionPaso}}></p><br/>
                                                                            </div>
                                                                        </li>
                                                                    )
                                                                })
                                                            }
                                                        </ol>
                                                        <p>En casos extraordinarios si no nos es posible determinar la procedencia del evento solicitaremos más información sobre los hechos y/o documentación adicional.</p>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        )
                                    })
                                )
                            }
                        </Accordion>
                    </div>

                    {/* VERSION DESKTOP */}
                    <div className="col-lg-7 d-none d-lg-block body__siniestro">
                        <div>
                            <ul id="pr" className="nav nav-perfil-links">
                                {
                                    siniestros && (
                                        siniestros.map((siniestro,index) => {
                                            return (
                                                <li key={`${index}-li-1`} index={index} className={(index === 0 ? "nav-item item_activado" : "nav-item" )} onClick={() => tabs_perfil(`${siniestro.id}`)} >
                                                    <div className="nav-link navSiniestro active  " data-toggle="tab">
                                                       <strong className=' h4 fw-semibold  ' >  {siniestro.tituloTab}</strong>
                                                    </div>
                                                </li>
                                            )
                                        })
                                        
                                    )
                                }
                            </ul>
                        </div>
                       
                        <div style={{ background: 'var(--gris-claro)'}}>
                            <div className="tab-content div-siniestro">
                                {
                                    siniestros && (
                                        siniestros.map((siniestro,index) => {
                                            let pasoFiltrados = pasosSiniestros.filter((ps) =>  ps.idTabSiniestro === siniestro.id)
       
                                            return (
                                                <div key={index+"-div"} className={ index === 0 ? "tab-pane container texto__siniestro__div active" : "tab-pane texto__siniestro__div container"}>
                                                    <p>Para hacer efectivo el pago de la indemnización por esta cobertura, deberás contar con los siguientes documentos:</p>
                                                    <br/>
                                                    <ol className=" texto__siniestro list-group-numbered">
                                                        {
                                                            pasoFiltrados.map((paso,indexPaso) => {
                                                                return (
                                                                    <li key={`${indexPaso}-li-2`} className="list-group-item d-flex justify-content-between align-items-start">
                                                                        <div className="ms-2 me-auto paso__siniestro">
                                                                            <p dangerouslySetInnerHTML={{__html: paso.descripcionPaso}}></p>
                                                                        </div>
                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                    </ol>
                                                    <br/>
                                                    <p>En casos extraordinarios si no nos es posible determinar la procedencia del evento solicitaremos más información sobre los hechos y/o documentación adicional.</p>
                                                </div>
                                            )
                                        })
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Siniestro